'use client';

import { useSearchParams } from "next/navigation";
import Link from 'next/link';

export default function LinkWithParams({href, children, ...props}) {
    const searchParams = useSearchParams();
    const currentParams = searchParams.toString();

    const hrefWithParams = currentParams ? `${href}?${currentParams}` : href;
    
    return (
        <Link href={hrefWithParams} {...props}>
            {children}
        </Link>
    );
}